export const list = {
  appKey: {
    name: 'Key',
    key: 'appKey',
    show: true,
  },
  appName: {
    name: '平台名称',
    key: 'appName',
    show: true,
  },
  isEnabled: {
    name: '状态',
    key: 'isEnabled',
    show: true,
  },
  remark: {
    name: '备注',
    key: 'remark',
    show: true,
  },
  verifyRemark: {
    name: '操作',
    key: 'verifyRemark',
    show: true,
    width: 200,
    custom: true,
    fixed: 'right'
  },
};
